<template>
  <div class="case-detail-gene-quality-dailog dialog col-block">
    <div class="title-container row-block">
      <div class="title">{{ $t('DIALOG.caseDetailGeneQuality.___title') }}</div>
      <div :style="{ flex: 1 }"></div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="data-container col-block" v-for="(variant, vkey, vindex) in variants" :key="vindex">
      <div class="data-title-container row-block">
        <div class="data-title">{{ variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -' }}</div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div :style="{ height: '15px' }"></div>
      <div class="data-content-container col-block flex-start width-full">
        <geneQualityData
          :isFamily="gene.dataType === 'monitor' ? !!variant.fam_info : project.fam_analyze"
          :gene="gene"
          :variant="variant"
          :coverages="coverages"
          :sampleAllelegts="sampleAllelegts"
        ></geneQualityData>
      </div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___return') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import geneQualityData from '../caseDetail/geneQualityData.vue'

export default {
  components: {
    geneQualityData
  },
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    // param
    project () {
      return this.param.project
    },
    gene () {
      return this.param.gene
    },
    variants () {
      return this.param.variants
    },
    coverages () {
      return this.param.coverages
    },
    sampleAllelegts () {
      return this.param.sampleAllelegts
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/caseDetailGeneQuality.vue